
import angular from "angular";

import DependencyListBuilder from "../../utility/DependencyListBuilder";

import EventFilterPanelController from "./EventFilterPanelController";


const EventFilterPanelComponent = {
    name: "tbEventFilterPanel",
    config: {
        template: EventFilterPanelController.template,
        bindings: {
            eventFilterData: "<tbEventFilterData",
            applyEventFilterFn: "&tbApplyEventFilterFn",
            additionalMainPanelClasses: "@tbAdditionalMainPanelClasses",
            additionalBottomPanelClasses: "@tbAdditionalBottomPanelClasses",
            additionalFilterFormClasses: "@tbAdditionalFilterFormClasses",
            showEventNameFilter: "<tbShowEventNameFilter",
            showEventTypeFilter: "<tbShowEventTypeFilter",
            showEventTargetFilters: "<tbShowEventTargetFilters",
            showEventStatusFilters: "<tbShowEventStatusFilters",
            showEventTrackerFilters: "<tbShowEventTrackerFilters",
            showEventLocationFilters: "<tbShowEventLocationFilters",
            showEventDateRangeFilters: "<tbShowEventDateRangeFilters",
            showEventReportedDateRangeFilters: "<tbShowEventReportedDateRangeFilters",
            useWideLayout: "=tbUseWideLayout"
        },
        controller: EventFilterPanelController, //injector info in $inject
        controllerAs: "eventFilterPanel"
    }
};

let eventFilterPanelComponentDependencies = DependencyListBuilder([
    EventFilterPanelController.dependencies
]);

export default angular
    .module(
        "trackerbase-app.views.event-filter-panel",
        eventFilterPanelComponentDependencies
    )
    .component(EventFilterPanelComponent.name, EventFilterPanelComponent.config)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/event-filter-panel/EventFilterPanel.js
// module id = wYV5
// module chunks = 1